import { Navigate, useParams } from 'react-router-dom';

/** 旧 URL /article-detail/:id を /articles/:id へ恒久的に寄せる（クライアント側） */
export function LegacyArticleDetailRedirect() {
  const { id } = useParams<{ id: string }>();
  if (id) {
    return <Navigate to={`/articles/${id}`} replace />;
  }
  return <Navigate to="/articles" replace />;
}
